import packageJson from '../../package.json';

export const baseEnvironment: {
  development: boolean;
  version: string;

  TENANT_ID: number | null;

  DEBUG: boolean;
  DEBUG_LEVEL: number;
  PERMISSIONS_BYPASS: boolean;

  LOCAL: boolean;

  PENDINGREQUESTAPI: number;
  SERVER_URL: string;

  GRAPHQL_SERVER_CONFIG: {
    url: string;
    local_urls: {
      user: string;
    };
  };

  STRAPI_SERVER_CONFIG: {
    url: string;
    token: string;
  };
  GTM: string;
  IS_MAINTENANCE_ENABLED: boolean;

  APP_NAME: string;
  MAIN_COLOR: string;
  PWAACTIVE: boolean;

  TRANSLATION: {
    DEFAULT: string;
    SUPPORTEDLANGUAGES: string[];
  };

  AUTH0: {
    domain: string;
    clientId: string;
    cacheLocation: 'localstorage';
    authorizationParams: {
      audience: string;
      redirect_uri: string;
    };

    httpInterceptor?: {
      allowedList: {
        uri: string;
      }[];
    };
  };
  CHIFT: {
    enable: boolean;
  };
  PLANNING: {
    enable: boolean;
  };
  FINANCIAL_CENTER: {
    enable: boolean;
  };
  CONTACT: {
    enable: boolean;
  };
  PROJECT: {
    enable: boolean;
  };
  ITEM: {
    enable: boolean;
  };
  DOMICILIATION: {
    enable: boolean;
  };
} = {
  development: false,
  version: packageJson.version,

  TENANT_ID: null,
  DEBUG: false,
  LOCAL: false,
  DEBUG_LEVEL: 0,
  PERMISSIONS_BYPASS: true,

  PENDINGREQUESTAPI: 5,
  SERVER_URL: '',
  GRAPHQL_SERVER_CONFIG: {
    url: '',
    local_urls: {
      user: '',
    },
  },
  STRAPI_SERVER_CONFIG: {
    url: 'https://cms-test.merlinsoftware.be/graphql',
    token:
      '26392b7e68bcaf00a7a1ab8a124957c3b3fa81d92c3cefcc89ed60734d409b8696734c7f718769243106c9617f84cc574a5219b9282b4c13f770158be82b20d391351aa0f352e3f5e5ecd7d5f326ae9baba4b0ae8232eef17f20058e4bb92de41273762111ea5f8f84fe258eb718d6e862eea5f7c8186388ce28810a39f27b69',
  },
  GTM: '',
  IS_MAINTENANCE_ENABLED: false,

  APP_NAME: 'Merlin Application',
  MAIN_COLOR: 'white',
  PWAACTIVE: true,

  TRANSLATION: {
    DEFAULT: 'fr',
    SUPPORTEDLANGUAGES: ['fr', 'en', 'nl', 'es'],
  },

  AUTH0: {
    domain: 'merlinsoftware-dev.eu.auth0.com',
    clientId: '0NLd1vuhsVQ6qQZkxDCdeeZ70rA3kfwZ',
    cacheLocation: 'localstorage',
    authorizationParams: {
      audience: 'https://api-dev.merlinsoftware.be',
      redirect_uri: window.location.origin,
    },
    httpInterceptor: {
      allowedList: [
        {
          uri: 'https://api-dev.merlinsoftware.be/*',
        },
        {
          uri: 'https://localhost:4200/*',
        },
      ],
    },
  },

  CHIFT: {
    enable: false,
  },
  PLANNING: {
    enable: false,
  },
  FINANCIAL_CENTER: {
    enable: false,
  },
  CONTACT: {
    enable: false,
  },
  PROJECT: {
    enable: false,
  },
  ITEM: {
    enable: false,
  },
  DOMICILIATION: {
    enable: false,
  },
};
